import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Departement } from '../../models/departement';
import { Statistics } from '../../services/statistics.service';

@Component({
  selector: 'app-statistics-actions',
  templateUrl: './stats-actions.component.html',
  styleUrls: ['./stats-actions.component.scss'],
})
export class StatsActionsComponent implements OnInit {
  departements: Departement[] = [];

  selectedDepartement?: Departement;

  @Output() selectedDepartementEvent = new EventEmitter<Departement>();

  constructor(private statisticsService: Statistics) {}

  ngOnInit(): void {
    this.init();
  }

  private async init() {
    this.departements = await this.statisticsService.getDepartements();
  }

  selectDepartement() {
    this.selectedDepartementEvent.emit(this.selectedDepartement);
  }
}
